import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

import { from, BehaviorSubject, Observable, interval, of } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
import { groupBy, map as _map, orderBy } from 'lodash'
  ;
interface Row {
  id?: number;
  modified?: Date;
  modifierRef?: number;
  created?: Date;
  creatorRef?: number;
}

export interface ListingRow extends Row {
  values: any;
  SortTitle: unknown;
  FacilityRef: number;
  Display: string;
  Division?: string;
  Category?: string;
  Section?: string;
  Group?: string;
  Form?: string;
  Location: string;
  Item: string;
  NextInspectionDate: Date;
  Pass_0?: 1 | 0 | null;
  NotesDeficiencies?: string;
  CorrectiveActions?: string;
  New_0: number;
  Type: string;
  __FormRef: string;
  Lookup: string;
  divisionName: string;
  userAnswer: any;

}

export interface AuthRow extends Row {
  guest: number;
  first_name: string;
  last_name: string;
  id: number;
}

export interface ListingChildren {
  label: string;
  children: ListingRow[];
}

interface QueryObject {
  slice: number;
  fields?: { [key: string]: string };
}
interface Schema {
  listing: QueryObject;
  parent: number;
  details: number;
}

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  slices: Schema = {
    listing: {
      slice: 53213,
      fields: {
        id: 'id',
        FacilityRef: 'FacilityRef',
        Display: 'Display',
        Location: 'Location',
        Form: 'Form',
        Item: 'Item',
        NextInspectionDate: 'NextInspectionDate',
        Group: 'Group',
        Division: 'Division',
        Category: 'Category',
        Section: 'Section',
        Lookup: 'Lookup',
        DatePrompt_0: 'DatePrompt_0',
        FirefighterPrompt_0: 'FirefighterPrompt_0',
        CommentPrompt_0: 'CommentPrompt_0',
        Sort: 'Sort',
        Type: 'Type',
        Options: 'Options',
        SortTitle: 'SortTitle',
        Required_0: 'Required_0',
        Feedback: 'Feedback',
        PromptVehicle_0: 'PromptVehicle_0',
        Instructions: 'Instructions',
        PromptStation_0: 'PromptStation_0'
      }
    },
    parent: 53253,
    details: 53263
  };

  error = new BehaviorSubject<string>(null);

  private _cache = {
    listings: new BehaviorSubject<ListingRow[]>(null),
    allListings: new BehaviorSubject<ListingRow[]>(null),
  };

  constructor(private api: ApiService) {

  }

  getListings() {
    return this._cache.listings.pipe(
      filter((x) => !!x),
      map((rows) => rows.filter((row) => !row.FacilityRef))
    );
  }

  insertData(request) {
    return this.api.request({
      "$/slice/xinsert": {
        slice: 51422,
        rows: [request],
      },
    });
  }
  updateData(request) {
    return this.api.request({
      "$/slice/xupdate": {
        slice: 51422,
        rows: [request],
      },
    });
  }
  updateDate(request) {
    request.Pickup = new Date();

    return this.api.request({
      '$/slice/xupdate': {
        slice: 51422,
        rows: [request]
      },
      $pop: 'keys'
    });
  }
  getAllUsers() {
    return this._request({
      '$/slice/report': {
        slice: 51085,
        where: ['$and',
          ['$and',
            ['$neq', ['$field', 'full_name'], null],
            ['$neq', ['$field', 'full_name'], ', ']
          ],
          ['$eq', ['$field', 'status'], 'ACTIVE']
        ],
        order: [['$asc', ['$field', 'full_name']]]
      },
      '$pop': 'rows'
    })
  }

  getListingChildren(id: number): Observable<any[]> {
    return this._cache.allListings.pipe(
      filter((x) => !!x),
      map((rows) => rows.filter((row) => row.FacilityRef === id)),
      map((rows) =>
        Array.from(new Set<string>(rows.map((row) => row.Location))).map(
          (group) => {
            return {
              children: _map(
                groupBy(
                  rows.filter((row) => row.Location === group),
                  (x) => x.Group
                ),
                (value, key) => ({
                  sectionName: key,
                  values: orderBy(value, (t) => t.SortTitle)
                })
              ),
              label: group
            };
          }
        )
      )
    );
  }

  getCalls() {
    var start = new Date();
    start.setUTCHours(0, 0, 0, 0);

    return this._request({
      '$/slice/report': {
        slice: 51422,
        where: ['$and',
          ['$and',
            ['$is', ['$field', 'Pickup'], null],
            ['$gte', ['$field', 'Call'], start],
          ],
        ],
        order: [['$desc', ['$field', 'id']]]
      },
      '$pop': 'rows'
    })
  }
  getDoNotCalls(number){
    return this._request({
      '$/slice/report': {
        slice: 51422,
        where: ['$and',
          ['$and',
            ['$is', ['$field', 'PhoneNumber'], number],
            ['$is', ['$field', 'Response'], '2'],
          ],
        ],
        order: [['$desc', ['$field', 'id']]]
      },
      '$pop': 'rows'
    })
  }
  getStationsRoster() {

    return this._request({
      '$/slice/report': {
        slice: 54506,
        order: [['$asc', ['$field', 'id']]]
      },
      '$pop': 'rows'
    })
  }







  private _query<T>(query: any) {
    return this._request<{ rows: T[] }>(query).pipe(map((resp) => resp.rows));
  }

  private _request<T>(query: any) {
    return from(
      new Promise<T>((res) => {
        this.api
          .request(query)
          .toPromise()
          .then((resp: any) => res(resp))
          .catch((err) => {
            console.warn(err);
            const e = err.error;
            this.error.next(e && e.error ? e.error : 'unknown_error');
          });
      })
    );
  }
}
